import getCompliance from './getCompliance'
import getControllers from './getControllers'
import getQueryDetails from './getQueryDetails'
import getRecord from './getRecord'

export const getCompliancePromise = getCompliance
export const getControllersPromise = getControllers
export const getQueryDetailsPromise = getQueryDetails
export const getRecordPromise = getRecord